import {useState,useEffect} from 'react'
import IndependentResearcherHome from './IndependentResearcherHome'
import { useNavigate, useSearchParams } from 'react-router-dom';
import ResearcherNavbar from './ResearcherNavbar';
import MarketPlaceFeedNavbar from '../MarketPlaceFeedNavbar';
const BASE_URL = process.env.REACT_APP_BASE_URL;

const IndependentResearcherLayout = () => {
const navigate = useNavigate();
const [profileExists, setProfileExists] = useState(false);
const [loading, setLoading] = useState(true);

useEffect(() => {
  const fetchProfile = async () => {
    try {
      const res = await fetch(`${BASE_URL}/marketplace/researcher/profile`, {
        headers: {
          Authorization: `Bearer ${localStorage.getItem("access_token")}`,
          "Content-Type": "application/json",
          "x-api-key": process.env.REACT_APP_X_API_KEY,
        },
      });

      const data = await res.json();
      // console.log("The my data is:",data)
      if (!res.ok || !data || data.has_profile === false) {
        navigate("/marketplace/independent_researcher/profile");
        setProfileExists(false);
      } else {
        setProfileExists(true);
      }
    } catch (err) {
      console.error(err);
      navigate("/marketplace/independent_researcher/profile");
      setProfileExists(false);
    } finally {
      setLoading(false);
    }
  };

  fetchProfile();
}, [navigate]);

// 🔥 UI Rendering
if (loading) {
  return (
    <div className="flex items-center justify-center h-screen bg-gray-50">
      <div className="flex flex-col items-center gap-4">
        <div className="w-10 h-10 border-4 border-blue-500 border-t-transparent rounded-full animate-spin"></div>
        <p className="text-gray-600 text-sm">Loading your profile...</p>
      </div>
    </div>
  );
}

return (
  <>
    {/* {profileExists && ( */}
      <>
        <MarketPlaceFeedNavbar  />
        <IndependentResearcherHome />
      </>
    {/* )} */}
  </>
)}

export default IndependentResearcherLayout